import { CurrentSubscription, SubscriptionPlan } from 'models/SubscriptionPlan';
import { Tenant } from 'models/Tenant';
import { ApiPayload } from 'infrastructure/api/ApiTypes';
import { Api } from 'infrastructure/api/Api'

export const SubscriptionActionType = {
    FETCH_CURRENTSUBSCRIPTION: 'FETCH_CURRENTSUBSCRIPTION',
    FETCH_CURRENTSUBSCRIPTION_SUCCESS: 'FETCH_CURRENTSUBSCRIPTION_SUCCESS',
    FETCH_SUBSCRIPTIONPLANS: 'FETCH_SUBSCRIPTIONPLANS',
    FETCH_SUBSCRIPTIONPLANS_SUCCESS: 'FETCH_SUBSCRIPTIONPLANS_SUCCESS',
    EDIT_SUBSCRIPTIONPLAN: 'EDIT_SUBSCRIPTIONPLAN',
    EDIT_SUBSCRIPTIONPLAN_SUCCESS: 'EDIT_SUBSCRIPTIONPLAN_SUCCESS',
    SET_TENANTPLAN: 'SET_TENANTPLAN',
    SET_TENANTPLAN_SUCCESS: 'SET_TENANTPLAN_SUCCESS',
    API_ERROR: 'API_ERROR',
};

interface IFetchCurrentSubscriptionAction {
    type: typeof SubscriptionActionType.FETCH_CURRENTSUBSCRIPTION
    payload: ApiPayload,
    returnPayload: CurrentSubscription | null,
    meta: {
        isApiCall: boolean
    },
}

interface ISubscriptionPlansAction {
    type: typeof SubscriptionActionType.FETCH_SUBSCRIPTIONPLANS
    payload: ApiPayload,
    returnPayload: SubscriptionPlan[] | SubscriptionPlan,
    meta: {
        isApiCall: boolean
    },
}

interface ISetTenantPlanAction {
    type: typeof SubscriptionActionType.SET_TENANTPLAN
    payload: ApiPayload,
    returnPayload: Tenant | null,
    meta: {
        isApiCall: boolean
    },
}

export type ISubscriptionActions = IFetchCurrentSubscriptionAction | ISubscriptionPlansAction | ISetTenantPlanAction

const baseUrl = 'api/subscriptions';
export class SubscriptionActions {
    public static fetchCurrentSubscription(token: string): ISubscriptionActions {
        return {
            type: SubscriptionActionType.FETCH_CURRENTSUBSCRIPTION,
            payload: Api.fetchApiCall(baseUrl + '/current', token, SubscriptionActionType.FETCH_CURRENTSUBSCRIPTION_SUCCESS, SubscriptionActionType.API_ERROR),
            returnPayload: null,
            meta: {
                isApiCall: true
            },
        }
    }

    public static fetchSubscriptionPlans(token: string): ISubscriptionActions {
        return {
            type: SubscriptionActionType.FETCH_SUBSCRIPTIONPLANS,
            payload: Api.fetchApiCall(baseUrl, token, SubscriptionActionType.FETCH_SUBSCRIPTIONPLANS_SUCCESS, SubscriptionActionType.API_ERROR),
            returnPayload: [],
            meta: {
                isApiCall: true
            },
        }
    }

    public static editSubscriptionPlan(token: string, subscriptionPlan: SubscriptionPlan): ISubscriptionActions {
        return {
            type: SubscriptionActionType.EDIT_SUBSCRIPTIONPLAN,
            payload: Api.putApiCall(baseUrl + '/' + subscriptionPlan.id, token, SubscriptionActionType.EDIT_SUBSCRIPTIONPLAN_SUCCESS, SubscriptionActionType.API_ERROR, subscriptionPlan, true),
            returnPayload: SubscriptionPlan.empty(),
            meta: {
                isApiCall: true
            },
        }
    }

    public static setTenantPlan(token: string, tenantId: number, subscriptionPlanId: number): ISubscriptionActions {
        return {
            type: SubscriptionActionType.SET_TENANTPLAN,
            payload: Api.putApiCall(baseUrl + '/tenant/' + tenantId, token, SubscriptionActionType.SET_TENANTPLAN_SUCCESS, SubscriptionActionType.API_ERROR, { subscriptionPlanId }, true),
            returnPayload: null,
            meta: {
                isApiCall: true
            },
        }
    }
}
